import { render } from "./TheCartOrderComment.vue?vue&type=template&id=e08f9e16"
import script from "./TheCartOrderComment.vue?vue&type=script&lang=js"
export * from "./TheCartOrderComment.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__